import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, List, ListItem, ListItemText, IconButton, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Edit, Delete } from '@mui/icons-material';
import adminColorsService from '../../services/adminColorsService';

const AvailableColors = () => {
  const [colors, setColors] = useState([]);
  const [newColor, setNewColor] = useState({ name: '', hex: '' });
  const [editColor, setEditColor] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    adminColorsService.getColors().then(setColors).catch(() => setColors([]));
  }, []);

  const handleAddColor = async () => {
    try {
      const res = await adminColorsService.addColor(newColor);
      setColors([...colors, { ...newColor, id: res.id }]);
      setNewColor({ name: '', hex: '' });
    } catch (err) {
      // Optionally show error
    }
  };

  const handleEditColor = (color) => {
    setEditColor(color);
    setDialogOpen(true);
  };

  const handleSaveEdit = async () => {
    try {
      await adminColorsService.updateColor(editColor.id, editColor);
      setColors(colors.map(c => c.id === editColor.id ? editColor : c));
      setDialogOpen(false);
      setEditColor(null);
    } catch (err) {
      // Optionally show error
    }
  };

  const handleDeleteColor = async (id) => {
    try {
      await adminColorsService.deleteColor(id);
      setColors(colors.filter(c => c.id !== id));
    } catch (err) {
      // Optionally show error
    }
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight={700} mb={2}>Available Colors</Typography>
      <Box display="flex" gap={2} mb={3}>
        <TextField label="Color Name" value={newColor.name} onChange={e => setNewColor({ ...newColor, name: e.target.value })} size="small" />
        <TextField label="Hex Code" value={newColor.hex} onChange={e => setNewColor({ ...newColor, hex: e.target.value })} size="small" placeholder="#FFFFFF" />
        <Button variant="contained" onClick={handleAddColor} disabled={!newColor.name || !newColor.hex}>Add</Button>
      </Box>
      <List>
        {colors.map(color => (
          <ListItem key={color.id} secondaryAction={
            <>
              <IconButton edge="end" onClick={() => handleEditColor(color)} aria-label={`Edit ${color.name} color`}><Edit /></IconButton>
              <IconButton edge="end" color="error" onClick={() => handleDeleteColor(color.id)} aria-label={`Delete ${color.name} color`}><Delete /></IconButton>
            </>
          }>
            <Box width={24} height={24} borderRadius="50%" bgcolor={color.hex} border="1px solid #ccc" mr={2} />
            <ListItemText primary={color.name} secondary={color.hex} />
          </ListItem>
        ))}
      </List>
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Edit Color</DialogTitle>
        <DialogContent>
          <TextField label="Color Name" value={editColor?.name || ''} onChange={e => setEditColor({ ...editColor, name: e.target.value })} fullWidth margin="dense" />
          <TextField label="Hex Code" value={editColor?.hex || ''} onChange={e => setEditColor({ ...editColor, hex: e.target.value })} fullWidth margin="dense" />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDialogOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSaveEdit}>Save</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AvailableColors;
